export const API_BASE_URL =
  import.meta.env.VITE_API_URL || "";

export const API_PREFIX = "/api/v1";
export const CATEGORIES = {
  horizontal: [
    "[Horizontal] HR·Recruitment",
    "[Horizontal] CS·Customer Service",
    "[Horizontal] Finance·Accounting",
    "[Horizontal] Legal",
    "[Horizontal] IT·Security",
    "[Horizontal] Marketing",
    "[Horizontal] Sales·Sales",
    "[Horizontal] Procurement·Purchasing",
    "[Horizontal] Data Analysis",
    "[Horizontal] ESG",
    "[Horizontal] Others (R&D, Production·Manufacturing, Strategic Planning, QC·Quality Control, Safety·Environment)",
  ],
  vertical: [
    "[Vertical] Manufacturing·High-tech",
    "[Vertical] Finance·Banking",
    "[Vertical] Insurance",
    "[Vertical] Capital Markets",
    "[Vertical] Logistics·Distribution",
    "[Vertical] Healthcare·Medical",
    "[Vertical] Pharmaceuticals",
    "[Vertical] Energy",
    "[Vertical] Construction",
    "[Vertical] Public·Government",
    "[Vertical] Others (TMT·Media, Legal Services, Education·Academics, Mobility·Transport, Consumer Goods·F&B)",
  ],
  enabler: [
    "[Enabler] Agent Platform · Orchestration",
    "[Enabler] Evaluation · Observability",
    "[Enabler] RAG Infrastructure",
    "[Enabler] Fine-tuning Tools",
    "[Enabler] Security · Governance",
    "[Enabler] Training Data Construction",
    "[Enabler] Others (MLOps, IDP · Intelligent Document Processing, Vector DB, Guardrail Solutions)",
  ],
};